import React, { useState, useEffect } from 'react';
import { obtenerTodosLosPrestamos, obtenerTodosLosPrestamosPaginados } from '../../../services/PrestamosService';
import './index.css';
import { acortarTexto, formatearFecha } from '../../../utils/functions';

function Updates() {
    const [updatesData, setUpdatesData] = useState([]);
    useEffect(() => {
        const fetchPrestamos = async () => {
          try {
            const data = await obtenerTodosLosPrestamosPaginados(0, 3);
            setUpdatesData(data.content.slice(0, 3)); // Almacena solo los primeros 5 préstamos
          } catch (error) {
            console.error('Error al obtener los préstamos:', error);
          }
        };
    
        fetchPrestamos();
      }, []);
  return (
    <div className='updates-container'>
        {updatesData.map((update, index) => {
            return(
                <div className='update-item' key={update.idPrestamo}>
                    <img src={update.usuario.userPic} alt=''/>
                    <div className='noti'>
                        <div style={{ marginBottom: '0.5rem'}}>
                            <span>{update.usuario.nombreCompleto}</span>
                            <span> ha prestado el libro: <strong style={{ color: '#788097'}}>{acortarTexto(update.libro.titulo,50)} </strong> </span>
                        </div>
                        <span>{formatearFecha(update.fechaSolicitud)}</span>
                    </div>
                </div>
            )
        })}
    </div>
  )
}

export default Updates
